/*
Solid Surface

--manufacturer <Manufacturer>
--manufacturerNumber <string>
--computerEaseNumber <string>
*/
import sheetStockFormFields from '@/modules/standardItems/schemas/sheetStock/form'

import { manufacturer, manufacturerNumber, computerEaseNumber } from '@/modules/standardItems/schemas/baseFormFields'

export default [
  ...sheetStockFormFields(),
  manufacturer({ classes: ['xs12', 'sm4'] }),
  manufacturerNumber({ classes: ['xs12', 'sm4'] }),
  computerEaseNumber()
]
